<template>
  <div class="planning-visual" aria-hidden="true">
    <div class="planning-visual__title">
      <span>Week 42</span>
      <span class="planning-visual__planned">€ 18.940 gepland</span>
    </div>

    <div class="planning-visual__grid">
      <span></span>
      <span v-for="day in days" :key="day" class="planning-visual__day">{{ day }}</span>

      <template v-for="installer in installers" :key="installer.name">
        <div class="planning-visual__installer">
          <ShowcaseAvatar :person="installer.person" />
          <span>{{ installer.name }}</span>
        </div>
        <div v-for="(slot, index) in installer.slots" :key="index" class="planning-visual__slot">
          <div
            v-if="slot"
            class="planning-visual__appointment"
            :class="`planning-visual__appointment--${APPOINTMENT_TONES[slot.type]}`"
          >
            <span>{{ slot.type }}</span>
            <small>{{ slot.customer }}</small>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import ShowcaseAvatar from './ShowcaseAvatar.vue';

  const APPOINTMENT_TONES = {
    Inmeting: 'blue',
    Montage: 'green',
    Service: 'orange',
    Levering: 'purple',
  };

  export default {
    name: 'PlanningVisual',
    components: { ShowcaseAvatar },
    setup() {
      const days = ['ma', 'di', 'wo', 'do', 'vr'];

      const installers = [
        {
          name: 'Cas',
          person: 'cas',
          slots: [
            { type: 'Inmeting', customer: 'Fam. Vos' },
            { type: 'Montage', customer: 'J. Bakker' },
            { type: 'Montage', customer: 'J. Bakker' },
            null,
            { type: 'Service', customer: 'T. Bos' },
          ],
        },
        {
          name: 'Sander',
          person: 'sander',
          slots: [
            null,
            { type: 'Inmeting', customer: 'J. Drissen' },
            { type: 'Levering', customer: 'L. Mulder' },
            { type: 'Montage', customer: 'L. Mulder' },
            null,
          ],
        },
        {
          name: 'Bart',
          person: 'bart',
          slots: [
            { type: 'Montage', customer: 'Fam. Smit' },
            null,
            { type: 'Inmeting', customer: 'N. Hendriks' },
            { type: 'Montage', customer: 'E. Peters' },
            { type: 'Montage', customer: 'E. Peters' },
          ],
        },
      ];

      return { days, installers, APPOINTMENT_TONES };
    },
  };
</script>

<style scoped lang="scss">
  .planning-visual {
    width: 520px;
    max-width: 100%;
    padding: 18px;
    border: 1px solid var(--showcase-stroke);
    border-radius: 10px;
    background-color: var(--white);
    color: var(--showcase-ink);
    box-shadow:
      0 1px 2px rgba(0, 9, 33, 0.06),
      0 8px 24px rgba(0, 9, 33, 0.07);

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 14px;
      font-size: 15px;
      font-weight: 500;
      line-height: 22px;
    }

    &__planned {
      color: #009a5f;
      font-size: 13px;
      font-weight: 400;
      line-height: 20px;
    }

    &__grid {
      display: grid;
      grid-template-columns: 70px repeat(5, minmax(0, 1fr));
      gap: 4px;
    }

    &__day {
      padding-bottom: 4px;
      color: var(--showcase-muted);
      font-size: 11px;
      font-weight: 500;
      line-height: 16px;
      text-align: center;
    }

    &__installer {
      display: flex;
      align-items: center;
      gap: 6px;
      height: 52px;
      font-size: 12px;
      line-height: 18px;
    }

    &__slot {
      display: flex;
      height: 52px;
      padding: 3px;
      border-radius: 5px;
      background-color: #f6f7f9;
    }

    &__appointment {
      display: flex;
      flex: 1;
      flex-direction: column;
      min-width: 0;
      padding: 3px 6px;
      border-left: 3px solid var(--appointment-color);
      border-radius: 4px;
      background-color: var(--appointment-bg);
      font-size: 11px;
      line-height: 15px;
      white-space: nowrap;
      overflow: hidden;
      small {
        color: var(--showcase-text);
        font-size: 10.5px;
      }
      &--blue {
        --appointment-color: var(--showcase-primary);
        --appointment-bg: var(--showcase-blue-bg);
      }
      &--green {
        --appointment-color: #009a5f;
        --appointment-bg: var(--showcase-green-bg);
      }
      &--orange {
        --appointment-color: #e08a00;
        --appointment-bg: #fff0dd;
      }
      &--purple {
        --appointment-color: #7c4ddb;
        --appointment-bg: var(--showcase-purple-bg);
      }
    }
  }
</style>
